import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/purchases', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/purchases/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, purchaseData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/purchases', purchaseData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, purchaseData) {
      return new Promise((resolve, reject) => {
        const url = `/purchases/${purchaseData.id}`
        axios
          .put(url, purchaseData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/purchases/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
